import React, { useState, useEffect } from 'react';
import { TextField, Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { Paper } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const SalesmanDashboard = ({ onSelectCustomer }) => {
  const [customers, setCustomers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate(); // Initialize the useNavigate hook
  const handleSelectCustomer = (customer) => {
    console.log('Selected Customer:', customer);
    localStorage.setItem('customer', JSON.stringify(customer));
    // Redirect to the customer-specific dashboard, e.g.:
    navigate('/home');
  };
  useEffect(() => {
    const fetchCustomers = async () => {
      const salesman = JSON.parse(localStorage.getItem('salesman'));
      try {
        const response = await axios.get('https://avinandanserampore.com/api/get_customers.php', {
          params: { salesman_id: salesman.id },
        });
        setCustomers(response.data.customers || []);
        console.log(response.data.customers);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCustomers();
  }, []);

  const filteredCustomers = customers.filter((customer) =>
    (customer.customer_name || '').toLowerCase().includes((searchQuery || '').toLowerCase())
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={3}
      style={{ minHeight: '100vh', backgroundColor: '#f4f6f8' }}
    >
      <Typography variant="h4" gutterBottom style={{ color: '#3f51b5', fontWeight: 'bold' }}>
        Salesman Dashboard
      </Typography>
      <TextField
        label="Search Customers"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ maxWidth: '700px' }}
      />
      <Paper
        elevation={3}
        style={{
          width: '100%',
          maxWidth: '700px',
          height: '700px',
          overflowY: 'auto',
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
        }}
      >
        <List>
          {filteredCustomers.length === 0 ? (
            <Typography
              variant="body1"
              style={{ padding: '1rem', color: '#757575', textAlign: 'center' }}
            >
              No customers found.
            </Typography>
          ) : (
            filteredCustomers.map((customer) => (
              <ListItem
                key={customer.customer_id}
                button
                onClick={() => handleSelectCustomer(customer)}
                style={{
                  margin: '0.5rem',
                  borderRadius: '8px',
                  border: '1px solid #ddd',
                  backgroundColor: '#f9f9f9',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="h6" style={{ fontWeight: 'bold', color: '#3f51b5' }}>
                      {customer.customer_name}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" style={{ color: '#757575' }}>
                      {customer.address}
                    </Typography>
                  }
                />
              </ListItem>
            ))
          )}
        </List>
      </Paper>
    </Box>
  );
};


export default SalesmanDashboard;
